<template>
  <div class="validate-wrap">
    <modal
      transition-name="fade-side"
      appear
      :logo="showLogo"
      :comp="modalComponent"
      :handle-props="modalProps2"
      :handle-events="modalEvents"
      :key="componentResetKey"
    />
  </div>
</template>

<script>
import Modal from "@/components/shared/Modal";
import api from "@/api";
import Questions from "@/components/auth/Validate";
import AddBio from "@/components/auth/AddBio";
import SuccessMessage from "@/components/auth/SuccessMessage";
import AddPassword from "@/components/auth/AddPassword";
import blobMe from "../js/blob";
import moment from "moment";
import { mapState } from "vuex";
export default {
  components: {
    Modal,
  },
  data() {
    return {
      token: "",
      usr_id: "",
      succesfulText: "",
      componentResetKey: 0,
      questionList: [],
      activePage: 0,
      showLogo: true,
      modalEvents: {
        close: this.handleClose,
        next: this.handleNext,
        "next-success": this.handleSuccess,
        "next-password": this.handlePassword,
        "next-bio": this.handleBio,
      },
      addPassword: false,
      currentComponent: Questions,
      startDate: null,
      fairTitle: null,
      isUserInvalidMessage: null,
    };
  },
  computed: {
    ...mapState(["email", "fairConfig"]),
    modalComponent() {
      return this.currentComponent;
    },
    adminValidate() {
      return this.$route.query.q === "true";
    },
    isRegistered() {
      return this.$route.params.isRegistered || false;
    },
    progressBarData() {
      let data = {};
      data.currentIndex = this.activePage;
      data.arr = this.questionList.map((page) => {
        return page.title;
      });
      return data;
    },
    modalProps2() {
      const props = {
        ...this.modalProps,
      };

      if (
        this.$route.name === "Validate" &&
        this.progressBarData.currentIndex === this.questionList.length - 1
      ) {
        props.required = true;
      }

      return props;
    },
    modalProps() {
      if (this.startDate === null) {
        return null;
      }
      if (this.adminValidate) {
        let texts = this.fairConfig.FC_ADMINSMSG;

        //handles startdate formatting to local date format
        if (process.env.VUE_APP_I18N_LOCALE !== "en") {
          moment.locale("sr");
        }

        // texts[texts.length - 1] = this.fairTitle + texts[texts.length - 1] + moment(this.startDate, "YYYY-MM-DD HH:mm:ss").format("L")
        return {
          title: this.fairConfig.FC_ADMINSMSG_TITLE,
          texts,
          date:
            this.fairTitle +
            texts[texts.length - 1] +
            moment(this.startDate, "YYYY-MM-DD HH:mm:ss").format("L"),
        };
      }
      if (this.isRegistered) {
        let texts = this.fairConfig.FC_CONFIRMMAILMSG;
        return {
          title: this.fairConfig.FC_CONFIRMMAILMSG_TITLE,
          texts,
          shouldResendEmail: true,
          currentEmail: this.email,
          required: true,
        };
      }
      if (this.isUserInvalidMessage) {
        return {
          texts: [this.isUserInvalidMessage],
        };
      }
      return {
        ...this.questionList[this.activePage],
        progress: this.progressBarData,
      };
    },
    lastPage() {
      return this.activePage === this.questionList.length - 1;
    },
  },
  watch: {
    startDate: {
      handler() {
        this.componentResetKey++;
      },
    },
    currentComponent: {
      async handler(newComp) {
        if (newComp === Questions) {
          if (this.questionList.length === 0 && !this.adminValidate)
            this.loginWithToken();
        }
      },
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.getStartDateAndFairName();
      if (this.$route.query.token && this.$route.query.usrid) {
        this.token = this.$route.query.token;
        this.usr_id = this.$route.query.usrid;
        this.validate();
        // if usr_id and token are valid
        if (!this.isUserInvalidMessage) {
          await this.getQuestions();
          // edge cases
          if (
            this.questionList.length === 0 &&
            this.fairConfig.FC_REG_ADDBIO == 0 &&
            !this.adminValidate &&
            !this.addPassword
          )
            this.loginWithToken();
          if (
            this.questionList.length === 0 &&
            this.fairConfig.FC_REG_ADDBIO == 0 &&
            !this.adminValidate &&
            this.addPassword
          )
            this.currentComponent = AddPassword;
        }
      }
    },
    async validate() {
      try {
        let res = await api.validate({ token: this.token, usrid: this.usr_id });
        if (res.data.result === "ok") {
          this.currentComponent = SuccessMessage;
          if (res.data.status === "password") {
            this.addPassword = true;
          }
          this.componentResetKey++;
        }
      } catch (error) {
        this.isUserInvalidMessage = error.response.data.message || null;
      }
    },
    async getQuestions() {
      // if (this.questionList.length > 0) return
      try {
        let res = await api.getQuestions({
          polltype: "reg",
        });
        if (res.data.data.length > 0) {
          let mapper = (el) => {
            return {
              pls_id: el.pls_id,
              title: el.title,
              questions: el.data,
              button: true,
              required: el.required,
            };
          };
          this.questionList = this.questionList.concat(
            res.data.data
              .map(mapper)
              .filter((el) => el !== undefined)
              .sort((a, b) => a.pls_id - b.pls_id)
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleClose() {
      this.callApiForClosePoll(this.questionList[this.activePage].pls_id);
      this.loginWithToken();
    },
    async handleNext(val) {
      val = Object.entries(val);
      let answers = [];
      for (const pair of val) {
        await this.checkForConditional(pair[1]);
        if (typeof pair[1] === "object") {
          if (pair[1].pqa_id) {
            // select
            answers.push({
              pqt_id: `${pair[0]}`,
              answer: [`${[pair[1].pqa_id]}`],
            });
          } else {
            // checkbox
            let selected = [];
            for (let checkbox of Object.keys(pair[1])) {
              if (pair[1][checkbox]) {
                selected.push(checkbox);
              }
            }
            if (selected.length > 0) {
              answers.push({
                pqt_id: pair[0],
                answer: selected,
              });
            }
          }
        } else {
          // string
          answers.push({
            pqt_id: pair[0],
            answer: pair[1],
          });
        }
      }
      this.postAnswers(answers);
      if (this.lastPage) {
        this.loginWithToken();
        return;
      }
      this.activePage++;
      this.componentResetKey++;
    },
    async checkForConditional(ans) {
      if (ans.conditional) {
        let res = await api.getConditional(ans);
        let newPage = {
          // title: 'Additional Questions',
          questions: [],
          button: true,
          required: true,
        };
        for (const q of res.data.result) {
          newPage.questions.push(q);
        }
        // console.log(newPage);
        this.questionList.splice(this.activePage + 1, 0, newPage);
        // this.questionList.push(newPage);
        this.questionList = [...this.questionList];
        // console.log(this.questionList);
      }
    },
    async loginWithToken() {
      this.startLoading();
      try {
        let obj = {
          usr_id: this.$route.query.usrid,
          token: this.token,
        };
        let res = await api.loginWithToken(obj);
        let data = res.data;
        if (data.status === "moderatorValidate") {
          this.$router.push("/validate?q=true");
        }
        if (data.sid) {
          const sid = data.sid;
          localStorage.setItem("sid", sid);
          this.setLoggedIn(true);
          this.$router.push("/");
        }
      } catch (error) {
        this.stopLoading();
        this.openToast(this.$t("login.linkedInError"));
        this.$router.push("/login");
      } finally {
        this.stopLoading();
      }
    },
    async handleBio(val) {
      let formData = new FormData();
      let empty = true;
      if (val.avatar) {
        let avatar = blobMe(val.avatar.split(",")[1], "image/jpeg");
        console.log(avatar);
        formData.append("image", avatar);
        empty = false;
      }
      if (val.bioText) {
        formData.append("bio", val.bioText);
        empty = false;
      }
      if (!empty) {
        formData.append("usr_id", this.usr_id);
        formData.append("token", this.token);
        try {
          let res = await api.addBio(formData, this.usr_id);
          console.log(res);
        } catch (error) {
          console.log(error);
        }
      }
      this.currentComponent = Questions;
    },
    async postAnswers(answers) {
      await api.postAnswers(answers, this.usr_id, this.token);
    },
    async handleSuccess() {
      // await this.getQuestions();
      setTimeout(() => {
        this.showLogo = false;
      }, 300);
      if (this.addPassword) {
        this.currentComponent = AddPassword;
        return;
      }
      if (this.fairConfig.FC_REG_ADDBIO == 1) this.currentComponent = AddBio;
      else this.currentComponent = Questions;
    },
    async handlePassword(val) {
      try {
        await api.changePassword(val.password, this.usr_id, this.token);
        if (this.fairConfig.FC_REG_ADDBIO == 1) this.currentComponent = AddBio;
        else this.currentComponent = Questions;
      } catch (error) {
        console.log(error);
      }
    },
    async getStartDateAndFairName() {
      try {
        const res = await api.getStartDateAndFairName();
        this.startDate = res.data.start;
        this.fairTitle = res.data.fair_title;
        if (res.data.start === null) {
          this.startDate = true;
        }
      } catch (error) {
        console.log(error);
        this.startDate = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.validate-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("/background.png") center center / cover;
}
</style>
